module.exports = __webpack_public_path__ + "static/media/download.630dd89e.svg";